export default __webpack_public_path__ + "static/media/camera-default-s.b4d71e66.png";